import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIdeal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 16,
	viewBox: "0 0 19 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.4545 15.7263L0 15.7273V0H10.4545C14.7346 0.0600184 18.1818 2.94823 18.1818 7.86364C18.1818 12.779 14.7346 15.6663 10.4545 15.7263ZM10.3636 14.9091H0.818182V0.818182H10.3636C14.4689 0.838339 17.3636 3.5901 17.3636 7.86364C17.3636 12.1372 14.4689 14.8889 10.3636 14.9091Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.90905 8.90911H4.63632V13.8182H1.90905V8.90911ZM3.27268 8.18184C4.22663 8.18184 4.99996 7.40851 4.99996 6.45457C4.99996 5.50062 4.22663 4.72729 3.27268 4.72729C2.31874 4.72729 1.54541 5.50062 1.54541 6.45457C1.54541 7.40851 2.31874 8.18184 3.27268 8.18184Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.2454 7.18191C15.8125 1.90918 10.3635 1.90918 10.3635 1.90918H6.09082V13.8183H10.3635C10.3635 13.8183 16.1821 13.8183 16.2716 8.00009H14.2726V4.81827H15.0908V7.18191H16.2454ZM8.45446 4.81827H10.3635V5.63645H9.27264V6.00009H10.2726V6.72736H9.27264V7.18191H10.4545V8.00009H8.45446V4.81827ZM7.23933 6.40918C7.23933 5.63645 6.72718 5.63645 6.72718 5.63645H6.09082V4.81827H6.63627C6.63627 4.81827 7.99991 4.81827 7.99991 6.40918C7.99991 8.00009 6.63627 8.00009 6.63627 8.00009H6.09082V7.18191H6.72718C6.72718 7.18191 7.23933 7.18191 7.23933 6.40918ZM11.7931 4.81827H12.909L13.868 8.00009H13.0406L12.8686 7.39535H11.8197L11.6429 8.00009H10.8163L11.7931 4.81827ZM12.3514 5.65936L12.6374 6.59743H12.0601L12.3514 5.65936Z",
			fill: "#E54279"
		})
	]
});
export default SvgIdeal;
